// レスポンシブデザイン
export const MOBILE_BREAKPOINT = 600;

// アニメーション
export const ANIMATION_DURATION_SHORT = 0.03;
export const ANIMATION_DURATION_LONG = 0.18;
export const ANIMATION_EASING = "cubic-bezier(0.2, 0, 0, 1)";
